// extracted by mini-css-extract-plugin
module.exports = {"root":"Llama_root__2Br8J"};